export default __webpack_public_path__ + "static/media/mx_ine_ife_back.4b8bda2d.jpeg";